import React, { useState } from 'react';
import './index.scss';
import AccountNavigation from './AccountNavigation/AccountNavigation';
import OrderSummary from './OrderSummary/OrderSummary';

const OrderSummaryPage = (props) => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  return (
    <div className="c-account background-color-gray">
      <div className="c-account__wrapper">
        <AccountNavigation {...props} setIsOpenMenu={setIsOpenMenu} isOpenMenu={isOpenMenu} />
        <div className="c-account__content">
          <OrderSummary {...props} />
        </div>
      </div>
    </div>
  );
};

export default OrderSummaryPage;
